/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 242);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(74);
__webpack_require__(75);
__webpack_require__(243);

window.module = angular.module('RCP', ['COM']);

__webpack_require__(76);

__webpack_require__(79);
__webpack_require__(82);
__webpack_require__(85);
__webpack_require__(90);
__webpack_require__(86);
__webpack_require__(89);
__webpack_require__(77);
__webpack_require__(93);
__webpack_require__(94);
__webpack_require__(95);

angular.module('RCP').controller('recruitIdxCtrl', ["$scope", "$element", "service", "$timeout", "chatGlobal", function ($scope, $element, service, $timeout, chatGlobal) {
    console.log('this is recruitIdxCtrl');
    var d = $scope.d = {};
    var f = $scope.f = {};

    f.jump = function (seg) {
        var curObj = $element.find('#rct-' + seg + '-1510828044038');
        var curObjTop = curObj.offset().top;
        angular.element('html, body').animate({ scrollTop: curObjTop });
    };

    f.toLogin = function () {
        f.closeWin();
        service.common.toLogin();
    };

    f.closeWin = function () {
        d.tipDialog.close();
    };

    f.goReg = function () {
        f.jump('reg');
        f.closeWin();
    };

    f.seeRsm = function (rsmId) {
        var urlTemp = rcpAid.getUrl('简历预览', { 'osPre': true, 'rid': rsmId });
        window.open(urlTemp);
    };

    f.dialogOpen = function (dataTip) {
        console.log('this is dialogOpen');
        d.tipDialog.tipInfo = dataTip;
        d.tipDialog.open();
    };

    f.seeAgreement = function () {
        var urlTemp = DYCONFIG.sso.rUrl + 'sso/agreement.html';
        window.open(urlTemp);
    };

    function checkLogin() {
        $scope.$on('login', function (rs, data) {
            console.log('this is login broadcast', data);
            if (data) {
                window.location.href = '/recruit.html#!/discover';
            }

            $timeout(function () {
                console.log('this is chat init');
                if (!d.isIE9 && chatGlobal && typeof chatGlobal.init === 'function') {
                    var chatParam = data && data.uid ? '' : { anonymous: 1 };
                    chatGlobal.init(chatParam);
                }
            });
        });
    }

    function iframeInit() {
        console.log('this is iframInit');
        var url = DYCONFIG.sso.rUrl + 'sso/recruit-register.html';
        $element.find('#rct-reg-1510828044038')[0].src = url;
    }

    function init() {
        d.verifyImg = '';
        d.mark = '';

        d.password = '';
        d.phone = '';
        d.vefyCode = '';
        d.judgeNum = '';

        d.checking = 0;

        d.tipDialog = {
            title: '',
            hide: 'footer',
            hideBtn: true
        };

        d.timing = 0;

        d.isIE9 = rcpAid.isIE(9, 9);

        iframeInit();

        checkLogin();
    }

    init();
}]);

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('RCP').factory('spaceMethod', ['request', function (request) {
    var fsUrl = DYCONFIG.fs.rUrl;
    var courseUrl = DYCONFIG.course.rUrl;
    var ssoUrl = DYCONFIG.sso.rUrl;
    var extraUrl = DYCONFIG.extra.rUrl;
    var pes2Url = DYCONFIG.pes2.rUrl;
    var dmsUrl = DYCONFIG.studyCircle.rUrl;
    var imsdUrl = DYCONFIG.chat.rUrl;
    var countUrl = DYCONFIG.count.rUrl;
    var orderUlr = DYCONFIG.order.rUrl;
    var appraiseUrl = DYCONFIG.appraise.rUrl;

    var recruitUrl = DYCONFIG.recruit && DYCONFIG.recruit.rUrl || dmsUrl;

    return {
        listFile: function listFile(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/listFile',
                params: arg_params
            }, arg_filter || {}));
        },

        addFolder: function addFolder(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/addFolder',
                params: arg_params
            }, arg_filter || {}));
        },

        updateFile: function updateFile(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/updateFile',
                params: arg_params
            }, arg_filter || {}));
        },

        removeFile: function removeFile(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/removeFile',
                params: arg_params
            }, arg_filter || {}));
        },

        listArticle: function listArticle(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/listArticle',
                params: arg_params
            }, arg_filter || {}));
        },

        searchItem: function searchItem(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'art/api/searchItem',
                params: arg_params
            }, arg_filter || {}));
        },

        importExam: function importExam(arg_params, arg_filter) {
            if (angular.isDefined(arg_params)) {
                return courseUrl + 'usr/api/importExam2?token=' + rcpAid.getToken() + '&folder=' + arg_params.folder;
            }
        },

        confirmImport: function confirmImport(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/importExam2',
                params: arg_params
            }, arg_filter || {}));
        },

        listPaper: function listPaper(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/listPaper',
                params: arg_params
            }, arg_filter || {}));
        },

        transImgUrl: function transImgUrl(id) {
            return DYCONFIG.fs.down + '?mark=' + id + '&token=' + rcpAid.getToken();
        },

        delExam: function delExam(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/delExam',
                params: arg_params
            }, arg_filter || {}));
        },

        updateFileParent: function updateFileParent(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: fsUrl + 'usr/api/updateFileParent',
                params: arg_params
            }, arg_filter || {}));
        },

        getPersonalCenter: function getPersonalCenter(argParams, argFilter) {
            argParams.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: courseUrl + 'usr/api/personalHomePage',
                params: argParams
            };
            return request(angular.extend(option, argFilter || {}));
        },
        isTeacher: function isTeacher(argParams, argFilter) {
            argParams.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: courseUrl + 'usr/api/isTeacher',
                params: argParams
            };
            return request(angular.extend(option, argFilter || {}));
        },

        getUserAttrs: function getUserAttrs() {
            if (UINFO && UINFO.usr && UINFO.usr.attrs) {
                return UINFO.usr.attrs;
            }
        },

        userInfo: function userInfo(params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'sso/api/uinfo',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        updateUser: function updateUser(data, filter) {
            var option = {
                method: 'POST',
                url: ssoUrl + 'usr/api/update',
                params: {
                    token: rcpAid.getToken()
                },
                data: data
            };
            return request(angular.extend(option, filter || {}));
        },

        updateBuyOrg: function updateBuyOrg(data, filter) {
            var option = {
                method: 'POST',
                url: recruitUrl + 'usr/api/updateOrg',
                params: {
                    token: rcpAid.getToken()
                },
                data: data
            };
            return request(angular.extend(option, filter || {}));
        },

        removeOrgUser: function removeOrgUser(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: imsdUrl + 'usr/api/removeOrgUser',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        sendMessage: function sendMessage(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'tlogin/api/sendMessage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        requestMark: function requestMark(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'pub/api/requestMark',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        bindPhone: function bindPhone(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'tlogin/api/bindPhone',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        resetPassword: function resetPassword(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'tlogin/api/resetPwd',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        changePassword: function changePassword(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: ssoUrl + 'usr/api/changePassword',
                params: params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
            return request(angular.extend(option, filter || {}));
        },

        GCertList: function GCertList(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'cert/api/list',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        UCertStatus: function UCertStatus(data, filter) {
            var option = {
                method: 'POST',
                url: ssoUrl + 'cert/api/update',
                params: {
                    token: rcpAid.getToken()
                },
                data: data
            };
            return request(angular.extend(option, filter || {}));
        },

        searchUser: function searchUser(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: (params.orgClass ? imsdUrl : ssoUrl) + 'usr/api/search',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        createUser: function createUser(args, filter) {
            args.params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: ssoUrl + 'adm/api/createUser',
                params: args.params,
                data: args.data
            };
            return request(angular.extend(option, filter || {}));
        },

        updateRole: function updateRole(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'adm/api/updateRole',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        updatePrivate: function updatePrivate(data, filter) {
            data.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/updatePrivate',
                params: data
            };
            return request(angular.extend(option, filter || {}));
        },

        findUser: function findUser(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: ssoUrl + 'adm/api/findUser',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        updateAllUser: function updateAllUser(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'adm/api/updateAllUser',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        applyIntoOrg: function applyIntoOrg(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/applyIntoOrg',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        getOrgList: function getOrgList(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/listOrgs',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        getlistOrgUser: function getlistOrgUser(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/listUserOrg',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        createOrg: function createOrg(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/createOrg',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        updateOrg: function updateOrg(args, filter) {
            args.params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: ssoUrl + 'adm/api/updateUser',
                params: args.params,
                data: args.data
            };
            return request(angular.extend(option, filter || {}));
        },

        exist: function exist(arg_params, arg_filter) {
            return request(angular.extend({
                method: 'GET',
                url: ssoUrl + 'sso/api/exist',
                params: arg_params
            }, arg_filter || {}));
        },

        createOrgMember: function createOrgMember(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/createOrgMembers',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        getAllTags: function getAllTags(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/getAllTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        getOrgMember: function getOrgMember(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/listOrgMembers',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        createOrgTag: function createOrgTag(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/createOrgMemTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        modifyTag: function modifyTag(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/mdyOrgMemTag',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        modifyMembers: function modifyMembers(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'usr/api/modifyOrgMembers',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        verifyOrgUser: function verifyOrgUser(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: ssoUrl + 'adm/api/verifyOrgUser',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        createGroup: function createGroup(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'usr/api/createGroup',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        updateGroup: function updateGroup(args, filter) {
            args.params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: dmsUrl + 'usr/api/updateGs',
                params: args.params,
                data: args.data
            };
            return request(angular.extend(option, filter || {}));
        },

        resetGroup: function resetGroup(args, filter) {
            args.params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: imsdUrl + 'usr/api/resetGroup',
                params: args.params,
                data: args.data
            };
            return request(angular.extend(option, filter || {}));
        },

        getReportList: function getReportList(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: extraUrl + 'usr/api/listInfo',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        handleInfo: function handleInfo(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: extraUrl + 'usr/api/handleInfo',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        reportInfo: function reportInfo(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: extraUrl + 'usr/api/reportInfo',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        getIndexList: function getIndexList(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: pes2Url + 'usr/api/listPage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        loadItem: function loadItem(params, filter) {
            var option = {
                method: 'GET',
                url: pes2Url + 'pub/api/loadItem',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        updatePage: function updatePage(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/updatePage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        updateItem: function updateItem(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/updateItem',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        releasePage: function releasePage(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/releasePage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        searchCourse: function searchCourse(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: pes2Url + 'pub/api/searchTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        createPage: function createPage(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/createPage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        deletePage: function deletePage(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/deletePage',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        getSearchClassify: function getSearchClassify(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: pes2Url + 'pub/api/loadAllTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        updateTags: function updateTags(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: pes2Url + 'usr/api/updateTags',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        bindWx: function bindWx(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: DYCONFIG.sso.rUrl + 'pub/api/thirdLogin',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        unbindWx: function unbindWx(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: DYCONFIG.sso.rUrl + 'usr/api/thirdUnbind',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        createDiscuss: function createDiscuss(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: dmsUrl + 'usr/api/createDiscuss',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        searchDiscuss: function searchDiscuss(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'pub/api/searchV',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        removeDiscuss: function removeDiscuss(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'usr/api/delDiscuss',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        discussDetail: function discussDetail(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'pub/api/getDetail',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        updateDiscuss: function updateDiscuss(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: dmsUrl + 'usr/api/updateDiscuss',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        statTeacher: function statTeacher(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: countUrl + 'usr/api/statTeacher',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        statCourse: function statCourse(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: countUrl + 'usr/api/statCourse',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        listCompany: function listCompany(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/listCompany',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        listCompanyRecruits: function listCompanyRecruits(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/listCompanyRecruits',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        admlistOrder: function admlistOrder(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/listOrder',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        listRecruitDelivery: function listRecruitDelivery(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/listRecruitDelivery',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        listfindOrder: function listfindOrder(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: dmsUrl + 'adm/api/findOrder',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        createResume: function createResume(arg_data, arg_filter) {
            return request(angular.extend({
                method: 'POST',
                url: dmsUrl + 'usr/api/createResume',
                params: {
                    token: rcpAid.getToken()
                },
                data: arg_data
            }, arg_filter || {}));
        },

        updateResume: function updateResume(arg_data, arg_filter) {
            return request(angular.extend({
                method: 'POST',
                url: dmsUrl + 'usr/api/updateResume',
                params: {
                    token: rcpAid.getToken()
                },
                data: arg_data
            }, arg_filter || {}));
        },

        searchResume: function searchResume(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: dmsUrl + 'usr/api/searchResume',
                params: arg_params
            }, arg_filter || {}));
        },

        findContact: function findContact(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: courseUrl + 'usr/api/findContact',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        listWarning: function listWarning(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: countUrl + 'usr/api/listWarning',
                params: arg_params
            }, arg_filter || {}));
        },

        loadWarning: function loadWarning(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: countUrl + 'usr/api/loadWarning',
                params: arg_params
            }, arg_filter || {}));
        },

        updateWarning: function updateWarning(arg_data, arg_filter) {
            return request(angular.extend({
                method: 'POST',
                url: countUrl + 'usr/api/updateWarning',
                params: {
                    token: rcpAid.getToken()
                },
                data: arg_data
            }, arg_filter || {}));
        },

        updateCharacter: function updateCharacter(arg_param, arg_filter) {
            arg_param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: courseUrl + 'usr/api/updateCharacter',
                params: arg_param
            }, arg_filter || {}));
        },

        verifyRecruit: function verifyRecruit(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'adm/api/verifyRecruit',
                params: arg_params
            }, arg_filter || {}));
        },

        createRecruit: function createRecruit(args, filter) {
            if (!args.param) args.param = {};
            args.param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'usr/api/createRecruit',
                params: args.param,
                data: args.data
            }, filter || {}));
        },

        updateRecruit: function updateRecruit(args, filter) {
            if (!args.param) args.param = {};
            args.param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'usr/api/updateRecruit',
                params: args.param,
                data: args.data
            }, filter || {}));
        },

        listRecruit: function listRecruit(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/listRecruit',
                params: params
            }, filter || {}));
        },

        loadRecruit: function loadRecruit(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'pub/api/loadRecruit',
                params: params
            }, filter || {}));
        },

        changeRecruit: function changeRecruit(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/changeRecruit',
                params: params
            }, filter || {}));
        },

        inviteResume: function inviteResume(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/inviteResume',
                params: arg_params
            }, arg_filter || {}));
        },

        changeDeliver: function changeDeliver(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/changeDeliver',
                params: params
            }, filter || {}));
        },

        changeInvitation: function changeInvitation(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: dmsUrl + 'usr/api/changeInvite',
                params: params
            }, filter || {}));
        },

        resumeLoad: function resumeLoad(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/loadResume',
                params: params
            }, filter || {}));
        },
        resumeUpdate: function resumeUpdate(params, filter) {
            if (!params.param) params.param = {};
            params.param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'usr/api/updateResume',
                params: params.param,
                data: params.data
            }, filter || {}));
        },
        resumeSelectLoad: function resumeSelectLoad(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'pub/api/loadSearchTags',
                params: params
            }, filter || {}));
        },
        listDelivery: function listDelivery(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/listDelivery',
                params: params
            }, filter || {}));
        },
        listInvitation: function listInvitation(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/listInvitation',
                params: params
            }, filter || {}));
        },
        changeInvite: function changeInvite(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: dmsUrl + 'usr/api/changeInvite',
                params: params
            }, filter || {}));
        },
        listPost: function listPost(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: pes2Url + 'pub/api/loadPage',
                params: params
            }, filter || {}));
        },

        configCombo: function configCombo(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'adm/api/configCombo',
                params: arg_params
            }, arg_filter || {}));
        },

        deliverResume: function deliverResume(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/deliverResume',
                params: params
            }, filter || {}));
        },

        loadRecruitCompany: function loadRecruitCompany(params, filter) {
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'pub/api/loadCompany',
                params: params
            }, filter || {}));
        },

        listCombo: function listCombo(params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'adm/api/listCombo',
                params: params
            }, filter || null));
        },

        loadAllocation: function loadAllocation(params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'adm/api/loadAllocation',
                params: params
            }, filter || null));
        },

        updateAllocation: function updateAllocation(params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'adm/api/updateAllocation',
                params: params
            }, filter || null));
        },

        createCombo: function createCombo(params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'adm/api/createCombo',
                params: params
            }, filter || null));
        },

        updateCombo: function updateCombo(params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'adm/api/updateCombo',
                params: params
            }, filter || null));
        },

        removeCombo: function removeCombo(params, filter) {
            params = params || {};
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'adm/api/removeCombo',
                params: params
            }, filter || null));
        },

        listFileInfo: function listFileInfo(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: fsUrl + 'pub/api/listInfo',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        contactLoad: function contactLoad(params, filter) {
            params.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'GET',
                url: recruitUrl + 'usr/api/lookResume',
                params: params
            }, filter || {}));
        },

        listOrder: function listOrder(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/listOrder',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}));
        },

        findOrder: function findOrder(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/findOrder',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}));
        },

        admFindOrder: function admFindOrder(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/findOrder',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}));
        },

        cancelOrder: function cancelOrder(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: orderUlr + 'usr/api/cancelOrder',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}));
        },

        createOder: function createOder(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/buy',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}));
        },

        loadCombo: function loadCombo(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/loadCombo	',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}));
        },

        loadOrderInfo: function loadOrderInfo(arg_params, arg_filter) {
            arg_params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/loadOrderInfo',
                params: arg_params
            };
            return request(angular.extend(option, arg_filter || {}));
        },

        updateContract: function updateContract(params, filter) {
            params = params || {};
            params.param.token = rcpAid.getToken();
            return request(angular.extend({
                method: 'POST',
                url: recruitUrl + 'usr/api/updateContract',
                params: params.param,
                data: params.data
            }, filter || null));
        },

        downContract: function downContract(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/downContract',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        publishRctComment: function publishRctComment(data, filter) {
            var params = {};
            params.token = rcpAid.getToken();
            var option = {
                method: 'POST',
                url: recruitUrl + 'usr/api/publishComment',
                params: params,
                data: data
            };
            return request(angular.extend(option, filter || {}));
        },

        loadComment: function loadComment(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: appraiseUrl + 'pub/api/loadComment',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        loadRctComment: function loadRctComment(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'pub/api/loadComment',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        groupCrsAppraise: function groupCrsAppraise(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: courseUrl + 'usr/api/groupCrsAppraise',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        listWritingPart: function listWritingPart(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/listWritingPart',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        listWritingPartDetail: function listWritingPartDetail(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/listWritingPartDetail',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        loadWritingHeadDetail: function loadWritingHeadDetail(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/loadWritingPartDetailHeader',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        listManual: function listManual(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'pub/api/listManual',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        makeManual: function makeManual(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/makeManual',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        rctVRList: function rctVRList(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'adm/api/verifyRecruitList',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        rctListRsm: function rctListRsm(params, filter) {
            params.token = rcpAid.getToken();
            var option = {
                method: 'GET',
                url: recruitUrl + 'usr/api/listResume',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        },

        registerUser: function registerUser(params, filter) {
            var option = {
                method: 'POST',
                url: ssoUrl + 'sso/api/create',
                params: params
            };
            return request(angular.extend(option, filter || {}));
        }
    };
}]).run(["service", "spaceMethod", function (service, spaceMethod) {
    service.expand('spaceMethod', function () {
        return spaceMethod;
    });
}]);

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(78);
var _module = angular.module('RCP');
_module.directive("datetime", function () {
    return {
        template: '<span ng-style="style"><input type="text" ng-class="config.class" ng-model="value" placeholder="{{config.placeholder}}" ng-click="toggle($event)" ng-keydown="onkeydown($event)" ng-disabled="disabled" readonly /></span>',
        restrict: "E",
        replace: true,
        transclude: true,
        scope: {
            value: "=value",
            config: "=config",
            disabled: "=disabled"
        },
        controller: ["$scope", "$element", "$document", "$compile", "$interval", "datetimeService", function controller($scope, $element, $document, $compile, $interval, datetimeService) {

            $scope.style = { position: 'relative', display: 'inline-block', cursor: 'default' };
            if ($scope.config.noInput) {
                $scope.style.display = 'none';
            }

            $scope.onkeydown = function (ev) {
                if (13 === ev.keyCode || 32 === ev.keyCode) {
                    $scope.toggle(ev);
                }
            };

            $scope.toggle = function (ev) {
                if (datetimeService.tpl) {
                    $document.off('click.datetimedir');
                    datetimeService.tpl.remove();
                    if (datetimeService.tag === $element) {
                        delete datetimeService.tpl;
                        $interval.cancel(datetimeService.clockTimer);
                        return;
                    }
                }
                datetimeService.tag = $element;
                datetimeService.tpl = $compile('<datetime-tpl value="value" config="config"></datetime-tpl>')($scope);
                if ($scope.config.noInput) {
                    $scope.config.targetElement.append(datetimeService.tpl);
                } else {
                    $element.append(datetimeService.tpl);
                }

                $document.on('click.datetimedir', $scope.toggle);
                if (ev) {
                    ev.stopPropagation();
                }
            };
            datetimeService.toggle = $scope.toggle;
        }]
    };
});

_module.directive('datetimeTpl', function () {
    return {
        template: ['<div ng-class="timeFlag ? \'datetime-w and-time-style\' : \'datetime-w\'" ng-click="stopPropagation($event)">', '<div style="cursor:default">', '<em class="arrow-ic"></em>', '<div class="show-time-box">', '<div class="now-time">', '<p>当前时间</p>', '<span>{{clockString}}</span>', '</div>', '<div style="padding: 15px 0px;">', '<select ', 'class="hour" ', 'ng-options="item.str for item in hourList" ', 'ng-model="repeatData.hour" ', 'ng-change="change({hour: repeatData.hour})"></select>', '</div>', '<div>', '<select ', 'class="minute" ', 'ng-options="item.str for item in minuteList" ', 'ng-model="repeatData.minute" ', 'ng-change="change({minute: repeatData.minute})"></select>', '</div>', '</div>', '<div class="show-date-box">', '<div class="t">', '<a href="javascript:;" class="p" title="上一月" ng-click="mBefore()"></a>', '<a href="javascript:;" class="n" title="下一月" ng-click="mAfter()"></a>', '<select ', 'class="y" ', 'ng-options="item.str for item in yearList" ', 'ng-model="repeatData.year" ', 'ng-change="change({year: repeatData.year})"></select>', '<select ', 'class="m" ', 'ng-options="item.str for item in monthList" ', 'ng-model="repeatData.month" ', 'ng-change="change({month: repeatData.month})"></select>', '<div class="w">', '<h4>一</h4>', '<h4>二</h4>', '<h4>三</h4>', '<h4>四</h4>', '<h4>五</h4>', '<h4>六</h4>', '<h4>日</h4>', '</div>', '</div>', '<div class="c">', '<a ng-repeat="item in dayList" ng-class="item.class" ng-click="change({day: item})">{{item.val}}</a>', '</div>', '<div class="f">', '<a href="javascript:;" class="clear" ng-click="clearValue()">清空</a>', '<a href="javascript:;" class="today" ng-click="(!disableBackToToday)&&today()" ng-class="{\'disabled\': disableBackToToday}">今日</a>', '<a href="javascript:;" class="cancel" ng-click="cancel()">取消</a>', '</div>', '</div>', '</div>', '</div>'].join(''),
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            value: '=value',
            config: '=config'
        },
        controller: ["$scope", "$element", "$timeout", "$interval", "$document", "datetimeService", function controller($scope, $element, $timeout, $interval, $document, datetimeService) {

            function init() {
                var config = $scope.config;

                $scope.oldDate = new Date();
                $scope.newDate = new Date();
                $scope.curDate = new Date();
                $scope.repeatData = {};
                $scope.expiredFlag = config.style.match("expired");
                $scope.realFlag = config.style.match("real");
                $scope.timeFlag = config.style.match("time");
                $scope.formatType = $scope.timeFlag ? 'yyyy-MM-dd hh:mm' : 'yyyy-MM-dd';
                $scope.disableBackToToday = false;
            }

            $scope.setSelect = function (y, m, h, f) {
                $scope.yearList = pushOption(1901, y + 100, 4, ['year', y], '年');

                $scope.monthList = pushOption(0, 12, 2, ['month', m], '月');

                $scope.hourList = pushOption(0, 24, 2, ['hour', h], '点');

                $scope.minuteList = pushOption(0, 60, 2, ['minute', f], '分');
            };

            function withZero(num, len) {
                var str = num + '';
                while (str.length < len) {
                    str = '0' + str;
                }
                return str;
            }

            function pushOption(i, l, z, p, s) {
                var arr = [];
                while (i < l) {
                    var option = {
                        val: i,
                        str: withZero(p[0] === 'month' ? i + 1 : i, z) + (s || '')
                    };
                    arr.push(option);
                    if (option.val === p[1]) {
                        $scope.repeatData[p[0]] = option;
                    }
                    i += 1;
                }
                return arr;
            }

            function isValidDate(d) {
                if (Object.prototype.toString.call(d) === '[object Date]') {
                    return !isNaN(d.getTime());
                }
                return false;
            }

            $scope.setDay = function (y, m, d) {
                if ($scope.config.selectableTime) {
                    var start, end;
                    start = new Date($scope.config.selectableTime.start);
                    end = new Date($scope.config.selectableTime.end);
                    $scope.startDateTime = isValidDate(start) ? start : null;
                    $scope.endDateTime = isValidDate(end) ? end : null;
                }

                $scope.disableBackToToday = !isDayClickable(new Date());

                $scope.dayList = function () {
                    var arr = [];
                    var i = 0;
                    var newDate = new Date(y + '-' + (m + 1) + '-' + 1);
                    var getday = newDate.getDay() ? newDate.getDay() : 7;
                    var dayLen = getDayLen(y, m + 1);
                    while (i < 42) {
                        var num = i >= getday - 1 && i < dayLen + (getday - 1) ? i - (getday - 2) : '';
                        var c = num ? daytype(y, m, num) : 'd';
                        var option = {
                            val: num,
                            class: c
                        };
                        arr.push(option);
                        if (option.val === d) {
                            $scope.repeatData.day = option;
                        }
                        i += 1;
                    }
                    return arr;
                }();
            };

            function daytype(y, m, d) {

                var ny = $scope.newDate.getFullYear();
                var nm = $scope.newDate.getMonth();
                var nd = $scope.newDate.getDate();
                var cs = 'd ';
                var addClass = function addClass(flag) {
                    if (flag) {
                        cs += 'd-able ';
                    }
                    if (y === ny && m === nm && d === nd) {
                        cs += flag ? 'd-now ' : 'd-disabled ';
                    }
                };

                var valid = isDayClickable(new Date(y, m, d));

                addClass(valid);
                return cs;
            }

            function isDayClickable(day) {
                var valid = false;
                if (!isValidDate(day)) {
                    return valid;
                }

                var y = day.getFullYear();
                var m = day.getMonth();
                var d = day.getDate();

                var curr = new Date();
                var cy = curr.getFullYear();
                var cm = curr.getMonth();
                var cd = curr.getDate();

                var left, right;
                var startDateTime = $scope.startDateTime;
                var endDateTime = $scope.endDateTime;

                if (startDateTime) {
                    left = new Date(startDateTime.getFullYear(), startDateTime.getMonth(), startDateTime.getDate());
                }
                if (endDateTime) {
                    right = new Date(endDateTime.getFullYear(), endDateTime.getMonth(), endDateTime.getDate() + 1);
                }

                if (!startDateTime && !endDateTime) {
                    if ($scope.expiredFlag) {
                        right = new Date(cy, cm, cd);
                    } else if ($scope.realFlag) {
                        left = new Date(cy, cm, cd);
                    }
                }

                if (!left && !right) {
                    valid = true;
                } else {
                    var _date = new Date(y, m, d);
                    valid = left ? left <= _date : true;
                    if (valid && right) {
                        valid = _date < right;
                    }
                }

                return valid;
            }

            function isLeapyear(y) {
                return y % 4 === 0 && y % 100 !== 0 || y % 400 === 0;
            }

            function getDayLen(y, m) {
                return m === 1 || m === 3 || m === 5 || m === 7 || m === 8 || m === 10 || m === 12 ? 31 : m === 4 || m === 6 || m === 9 || m === 11 ? 30 : m === 2 && isLeapyear(y) ? 29 : 28;
            }

            function dateFormat(date, format) {
                var o = {
                    "M+": date.getMonth() + 1,
                    "d+": date.getDate(),
                    "h+": date.getHours(),
                    "m+": date.getMinutes(),
                    "s+": date.getSeconds(),
                    "q+": Math.floor((date.getMonth() + 3) / 3),
                    "S": date.getMilliseconds() };

                if (/(y+)/.test(format)) {
                    format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
                }

                for (var k in o) {
                    if (new RegExp("(" + k + ")").test(format)) {
                        format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
                    }
                }
                return format;
            }

            $scope.mBefore = function () {
                var month = $scope.curDate.getMonth() - 1;
                if (month < 0) {
                    $scope.curDate.setFullYear($scope.curDate.getFullYear() - 1);
                    month = 11;
                }
                $scope.curDate.setMonth(month);
                $scope.reset();
            };

            $scope.mAfter = function () {
                var month = $scope.curDate.getMonth() + 1;
                if (month > 11) {
                    $scope.curDate.setFullYear($scope.curDate.getFullYear() + 1);
                    month = 0;
                }
                $scope.curDate.setMonth(month);
                $scope.reset();
            };

            $scope.change = function (args) {
                angular.forEach(args, function (value, key) {
                    switch (key) {
                        case 'year':
                            $scope.curDate.setFullYear(value.val);
                            $scope.reset();
                            break;
                        case 'month':
                            $scope.curDate.setMonth(value.val);
                            $scope.reset();
                            break;
                        case 'day':
                            if (value.class.match(/d-able|d-now/)) {
                                $scope.curDate.setDate(value.val);
                                $scope.setValue($scope.curDate);
                                if (!$scope.timeFlag) {
                                    $element.remove();
                                    $interval.cancel(datetimeService.clockTimer);
                                    if (typeof $scope.config.getSelectDate === 'function') {
                                        $timeout(function () {
                                            $scope.config.getSelectDate($scope.value);
                                        });
                                    }
                                } else {
                                    $scope.reset();
                                }
                            }
                            break;
                        case 'hour':
                            $scope.curDate.setHours(value.val);
                            $scope.setValue($scope.curDate);
                            $scope.reset();
                            break;
                        case 'minute':
                            $scope.curDate.setMinutes(value.val);
                            $scope.setValue($scope.curDate);
                            $scope.reset();
                            break;
                    }
                });
            };

            $scope.clear = function (date, value, init) {
                var newDate = date || new Date();
                $scope.setData($scope.newDate, newDate);
                $scope.setData($scope.curDate, newDate);
                $scope.value = value || '';
                $scope.reset();
                if (!init) {
                    $element.remove();
                    $interval.cancel(datetimeService.clockTimer);
                }
            };

            $scope.clearValue = function () {
                var oldValue = $scope.value;
                $scope.clear();
                if (typeof datetimeService.onClear === 'function') {
                    datetimeService.onClear();
                }
                if (oldValue !== $scope.value && typeof $scope.config.getSelectDate === 'function') {
                    $timeout(function () {
                        $scope.config.getSelectDate($scope.value);
                    });
                }
            };

            $scope.today = function () {
                var oldValue = $scope.value;

                var newDate = new Date();
                $scope.clear(newDate, dateFormat(newDate, $scope.formatType));

                if (oldValue !== $scope.value && typeof $scope.config.getSelectDate === 'function') {
                    $timeout(function () {
                        $scope.config.getSelectDate($scope.value);
                    });
                }
            };

            $scope.cancel = function () {
                if ($scope.initValue) {
                    $scope.setValue($scope.oldDate);
                    $scope.reset();
                } else {
                    $scope.clear();
                }
                $element.remove();
                $interval.cancel(datetimeService.clockTimer);
            };

            $scope.stopPropagation = function (ev) {
                ev.stopPropagation();
            };

            $scope.setData = function (obj, date) {
                obj.setFullYear(date.getFullYear());
                obj.setMonth(date.getMonth());
                obj.setDate(date.getDate());
                obj.setHours(date.getHours());
                obj.setMinutes(date.getMinutes());
            };

            $scope.setValue = function (date) {
                $scope.setData($scope.newDate, date);
                $scope.setData($scope.curDate, date);

                $scope.value = dateFormat($scope.newDate, $scope.formatType);
            };

            $scope.reset = function () {
                var y = $scope.curDate.getFullYear();
                var m = $scope.curDate.getMonth();
                var d = $scope.curDate.getDate();
                var h = $scope.curDate.getHours();
                var f = $scope.curDate.getMinutes();

                $scope.setSelect(y, m, h, f);
                $scope.setDay(y, m, d);
            };

            $scope.clock = function () {
                var newDate = new Date();
                $scope.clockString = withZero(newDate.getHours(), 2) + ":" + withZero(newDate.getMinutes(), 2) + ":" + withZero(newDate.getSeconds(), 2);
            };

            $scope.locate = function () {
                var ww = angular.element(window).width();
                var wh = angular.element(window).height();
                var ew = $element.width();
                var eh = $element.height();
                var ph = $element.prev().height();
                var tSpace = $element.parent().offset().top - angular.element(window).scrollTop();
                var bSpace = wh - (tSpace + ph);
                var lSpace = $element.parent().offset().left;
                var rSpace = ww - (lSpace + ew);
                var top = 0;
                var left = 0;
                var count = function count(v, s, e, w) {
                    if (s + e > w) {
                        v = w - (s + e + 10);
                        if (v < -s) {
                            v = -s;
                        }
                    }
                    return v;
                };
                var yLocate = function yLocate(c) {
                    left = count(left, lSpace, ew, ww);
                    $element.addClass(c).css({ left: left });

                    $element.find('.arrow-ic').css({ left: -left + 20 });
                };
                var xLocate = function xLocate(c) {
                    top = count(top, tSpace, eh, wh);
                    $element.addClass(c).css({ top: top });
                    $element.find('.arrow-ic').css({ top: -top + ph / 2 });
                };
                var yfn = function yfn(c) {
                    if (lSpace + ew > ww && lSpace > ew) {
                        xLocate('dtt-w-l-sty');
                    } else if (lSpace < ew / 2 && rSpace > ew) {
                        xLocate('dtt-w-r-sty');
                    } else {
                        yLocate(c);
                    }
                };
                var xfn = function xfn(c) {
                    xLocate(c);
                };
                if ($scope.config.position) {
                    switch ($scope.config.position) {
                        case 'top':
                            yfn('dtt-w-t-sty');
                            break;
                        case 'bottom':
                            yfn('dtt-w-b-sty');
                            break;
                        case 'left':
                            xfn('dtt-w-l-sty');
                            break;
                        case 'right':
                            xfn('dtt-w-r-sty');
                            break;
                    }
                    return;
                }
                if (bSpace >= eh) {
                    yfn('dtt-w-b-sty');
                } else if (tSpace >= eh) {
                    yfn('dtt-w-t-sty');
                } else if (lSpace > rSpace) {
                    xfn('dtt-w-l-sty');
                } else {
                    xfn('dtt-w-r-sty');
                }
            };

            $scope.run = function () {
                $scope.initValue = $scope.value;
                var newDate = $scope.value ? new Date($scope.value.replace(/-|\./g, '/')) : new Date();
                if (!angular.isDate(newDate)) {
                    console.error('oldDate is not Date Object');
                    return;
                }

                if ($scope.value) {
                    $scope.setData($scope.oldDate, newDate);
                    $scope.clear(newDate, dateFormat(newDate, $scope.formatType), 'init');
                } else {
                    $scope.clear(newDate, '', 'init');
                }

                var y = $scope.oldDate.getFullYear();
                var m = $scope.oldDate.getMonth();
                var d = $scope.oldDate.getDate();
                var h = $scope.oldDate.getHours();
                var f = $scope.oldDate.getMinutes();

                $scope.setSelect(y, m, h, f);
                $scope.setDay(y, m, d);
                $timeout($scope.locate, 80);
                if ($scope.timeFlag) {
                    $scope.clock();
                    $interval.cancel(datetimeService.clockTimer);
                    datetimeService.clockTimer = $interval($scope.clock, 1000);
                }
            };

            init();
            $scope.run();
        }]
    };
});

_module.factory('datetimeService', function () {
    return {};
});
_module.run(["service", "datetimeService", function (service, datetimeService) {
    service.expand('datetimeService', function () {
        return datetimeService;
    });
}]);

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(80);
var templateUrl = __webpack_require__(81);


angular.module('RCP').directive('commonModal', function () {
    return {
        template: templateUrl,
        restrict: 'E',
        transclude: true,
        scope: {
            config: '='
        },
        controller: ["$scope", "$element", "$timeout", function controller($scope, $element, $timeout) {
            var modal = $($element[0]).find('.cm-modal');
            var modalMain = modal.find('.modal-main');

            $scope.ok = function () {
                if ($scope.dialog.autoClose) {
                    closeModal();
                }
                $scope.config.okCb && $scope.config.okCb();
            };

            $scope.cancel = function () {
                if ($scope.dialog.autoClose) {
                    closeModal();
                }
                $scope.config.cancelCb && $scope.config.cancelCb();
            };

            $scope.close = function () {
                closeModal();
                $scope.config.closeCb && $scope.config.closeCb();
            };

            $scope.init = function () {
                $scope.dialog = $scope.config || {};
                $scope.dialog.autoClose = angular.isUndefined($scope.dialog.autoClose) ? true : $scope.dialog.autoClose;

                $scope.config.open = function () {
                    openModal();
                };

                $scope.config.close = $scope.close;

                $scope.config.resize = function (argNeedAnimate) {
                    modal.css({ 'visibility': 'visible' });
                    if (argNeedAnimate) {
                        modalMain.animate({ 'margin-left': -modalMain.width() / 2, 'margin-top': -modalMain.height() / 2 });
                    } else {
                        modalMain.css({ 'margin-left': -modalMain.width() / 2, 'margin-top': -modalMain.height() / 2 });
                    }
                };

                $scope.config.refShow = function () {
                    hideHandler();
                };

                $scope.dialog.mask = angular.isUndefined($scope.config.mask) ? true : $scope.config.mask;
                $scope.dialog.autoClose = angular.isUndefined($scope.config.autoClose) ? true : $scope.config.autoClose;

                function hideHandler() {
                    if ($scope.dialog.hide) {
                        var _hideList = $scope.dialog.hide.split(',');
                        $scope.hideList = {};
                        angular.forEach(_hideList, function (value, key) {
                            $scope.hideList[value] = true;
                        });
                    }
                }

                hideHandler();
            };

            function openModal() {
                $scope.config.show = true;
                modal.css({ 'visibility': 'hidden' });
                $timeout(function () {
                    modal.css({ 'visibility': 'visible' });
                    modalMain.css({ 'margin-left': -modalMain.width() / 2, 'margin-top': -modalMain.height() / 2 });
                    rcpAid.toggleHtmlOverflowHidden(true);
                });
            }

            function closeModal() {
                $scope.config.show = false;
                rcpAid.toggleHtmlOverflowHidden(false);
            }

            $scope.init();
        }]
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

module.exports = "<div class=\"cm-modal scaleIn\" ng-class=\"dialog.theme || 'd-1'\" ng-show=\"dialog.show\">\n    <div class=\"bg-mask\" ng-show=\"dialog.mask\"></div>\n    <div class=\"modal-main\">\n        <div class=\"ml-header\" ng-hide=\"hideList.header\">\n            <span class=\"title\" ng-bind=\"dialog.title || '温馨提示'\"></span>\n            <a class=\"close\" ng-click=\"close()\" ng-hide=\"dialog.hideList.close\">×</a>\n        </div>\n        <div class=\"ml-body\" ng-transclude ng-hide=\"hideList.body\"></div>\n        <div class=\"ml-footer\" ng-hide=\"hideList.footer\">\n            <button class=\"ok\" ng-click=\"ok()\" ng-bind=\"dialog.okBtn || '确定'\" ng-hide=\"dialog.hideBtn.ok\"></button>\n            <button class=\"cancel\" ng-click=\"cancel()\" ng-bind=\"dialog.cancelBtn || '取消'\" ng-hide=\"dialog.hideBtn.cancel\"></button>\n        </div>\n    </div>\n</div>\n";

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(83);
var templateUrl = __webpack_require__(84);

angular.module('RCP').directive('ngImg', ["$document", function ($document) {
    return {
        template: templateUrl,
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            c: '='
        },
        controller: ["$scope", "$element", "$compile", "$timeout", function controller($scope, $element, $compile, $timeout) {
            try {
                var suImg = function suImg() {
                    try {
                        var w = $element.width(),
                            h = $element.height(),
                            imgw = 0,
                            imgh = 0,
                            imgStyle = angular.copy($scope.imgStyle);

                        if ($scope.auto) {
                            imgStyle.width = 'auto';
                            imgStyle.height = 'auto';
                        }
                        if ($scope.imgStyle.width || $scope.imgStyle.height) {
                            $scope.auto = true;
                        }
                        if ($scope.auto) {
                            imgStyle.visibility = 'visible';
                            $element.children().css(imgStyle);
                            return;
                        }
                        imgw = $element.children()[0].naturalWidth;
                        imgh = $element.children()[0].naturalHeight;
                        h = h || 1;
                        imgh = imgh || 1;

                        if (w / h > imgw / imgh) {
                            if ($scope.preview) {
                                imgStyle.height = '100%';
                                imgStyle.width = 'auto';
                            } else {
                                imgStyle.height = 'auto';
                                imgStyle.width = '100%';
                            }
                        } else {
                            if ($scope.preview) {
                                imgStyle.height = 'auto';
                                imgStyle.width = '100%';
                            } else {
                                imgStyle.height = '100%';
                                imgStyle.width = 'auto';
                            }
                        }
                        imgStyle.visibility = 'visible';
                        $element.children().css(imgStyle);
                    } catch (e) {}
                };
                var pushImg = function pushImg() {
                    if ($scope.isPushImg) {
                        return;
                    }
                    var temDefault = $scope.default || '',
                        imgClass = $scope.imgClass || '',
                        title = $scope.title || '';
                    var img = '<img ng-src="{{img}}" default="' + temDefault + '" class="ng-img ' + imgClass + '" title="' + title + '" style="visibility: hidden;" >';
                    $scope.isPushImg = true;
                    $element.html($compile(img)($scope));
                    $element.children().on('load', suImg);
                };
                $scope.init = function () {
                    $scope.img = '';
                    $scope.default = '';
                    $scope.title = '';
                    $scope.auto = false;
                    $scope.divStyle = {};
                    $scope.imgStyle = {};
                    $scope.isPushImg = false;
                    if ($scope.c) {
                        angular.forEach($scope.c, function (value, key) {
                            $scope[key] = value;
                        });
                    }
                    if ($scope.img) {
                        pushImg();
                    }
                    $scope.$watch('c', function (v, o) {
                        if (v && v !== o) {
                            angular.forEach($scope.c, function (value, key) {
                                $scope[key] = value;
                            });
                            if (!$scope.img) {
                                $scope.img = $scope.default;
                            }
                            pushImg();
                        }
                    });
                };
                $scope.init();
                $timeout(function () {
                    if ($scope.img) {
                        return;
                    }
                    pushImg();
                }, 500);
            } catch (e) {
                console.log(e);
            }
        }]
    };
}]);

angular.module('RCP').directive('img', ["$document", function ($document) {
    return {
        restrict: 'E',
        replace: true,
        link: function link($scope, $element, $attr) {
            var initImg = 'data:image/png;base64,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',
                defaultImg = $attr.default || initImg;

            function stop() {
                $element.off('error', errorImg);
            }

            function errorImg() {
                if (defaultImg) {
                    $element.attr('src', defaultImg);
                    defaultImg = '';
                } else {
                    $element.attr('src', initImg);
                }
            }
            if (!$attr.src) {
                $element.attr('src', defaultImg);
            }
            $element.on('error', errorImg);
        }
    };
}]);

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

module.exports = "<div class=\"ng-img-div\" ng-class=\"divClass\">\n</div>";

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('RCP').directive('maxLengthLimit', ["$timeout", function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModelCtrl) {
            var maxLength = Number(attrs.maxLengthLimit);

            ngModelCtrl.$parsers.push(function (text) {

                if (text.length > maxLength) {
                    var newStr = text.substr(0, maxLength);

                    $timeout(function () {
                        ngModelCtrl.$setViewValue(newStr);
                        ngModelCtrl.$render();
                    });
                    return newStr;
                }
                return text;
            });
        }
    };
}]);

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _fixedToolbarDir = __webpack_require__(87);

var _fixedToolbarDir2 = _interopRequireDefault(_fixedToolbarDir);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(88);

angular.module('RCP').directive("fixedToolbar", function () {
    return {
        template: _fixedToolbarDir2.default,
        restrict: "E",
        replace: true,
        transclude: true,
        scope: {
            data: "=data"
        },
        controller: ["$scope", "$rootScope", "$timeout", "service", "chatGlobal", function controller($scope, $rootScope, $timeout, service, chatGlobal) {
            $scope.f = {
                consult: '找客服聊天'
            };
            $scope.h = {
                listCustomService: '获取客服列表'
            };
            $timeout(function () {
                $scope.currentUser = $rootScope.currentUser;
            }, 0);
            $scope.d = {
                customList: [],
                isIE9: rcpAid.isIE(9, 9)
            };

            function init() {
                if (!$scope.data) {
                    $timeout(function () {
                        var temData = angular.fromJson(localStorage.headerFooterData) || {};
                        $scope.d.isIE9 = rcpAid.isIE(9, 9);
                        $scope.d.qr = temData.qrAppDown || {};
                        $scope.d.qr.src = rcpAid.safe($scope.d, 'qr.img', '');
                        $scope.d.wx = rcpAid.safe(temData, 'twoDimensionCode', {});
                        $scope.d.wx.src = rcpAid.safe($scope.d, 'wx.img', '');
                    }, 500);
                } else {
                    $scope.d = $scope.data;
                    $scope.d.isIE9 = rcpAid.isIE(9, 9);
                }
                if (rcpAid.safe($scope.d, 'qr.name')) {
                    $scope.d.qr.name = decodeURI($scope.d.qr.name);
                }
                if (rcpAid.safe($scope.d, 'wx.name')) {
                    $scope.d.wx.name = decodeURI($scope.d.wx.name);
                }

                $scope.h.listCustomService();
            }

            function handler() {
                var elem = $('.to-top');
                var top = $(window).scrollTop();
                if (top > 300) {
                    elem.addClass('visible');
                } else {
                    elem.removeClass('visible');
                }
            }

            $scope.f.consult = function (argData) {
                var temUid = '';
                if (argData) {
                    temUid = argData.id;
                } else if ($scope.d.customList.length === 1) {
                    temUid = rcpAid.safe($scope.d.customList, '0.id');
                }
                if (temUid) {
                    service.chatGlobal.chatById(temUid);
                }
            };

            $scope.h.listCustomService = function () {
                var data = {
                    count: 100
                };
                service.common.listCustomService(data).then(function (rs) {
                    $scope.d.customList = [];
                    $scope.d.customList = rs.data;
                }, function (e) {
                    service.dialog.showErrorTip(e, { moduleName: 'fixed-toolbar-dir', funcName: 'listCustomService' });
                });
            };
            init();
        }]
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"'fixed-toolbar '+param.style\">\n    <div class=\"kf\" ng-class=\"{'one-service':d.customList.length>1,'d-b':d.customList.length>0}\" title=\"联系客服\" ng-click=\"f.consult()\" ng-hide=\"d.isIE9\">\n        <i class=\"iconfont i-consult\"></i>\n        <span>联系客服</span>\n        <div class=\"l-ft\" ng-hide=\"d.customList.length == 1\">\n            <div class=\"kf-list\">\n                <div class=\"title\">请选择客服代表</div>\n                <div class=\"list\">\n                    <div class=\"item\" ng-repeat=\"c in d.customList track by $index\" ng-show=\"$index<19\" ng-click=\"f.consult(c)\">\n                        <ng-img class=\"avatar\" c=\"{img:c.attrs.basic.avatar}\"></ng-img>\n                        <div class=\"text-of c-name\">\n                            <span ng-bind=\"c.attrs.basic.nickName\" title=\"{{c.attrs.basic.nickName}}\">客服小强</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"kf\">\n        <i class=\"iconfont i-fuwurexian\"></i>\n        <span>客服热线</span>\n        <div class=\"l-ft contact-div\">\n            <div >\n                <i class=\"iconfont i-rightbar-phone f-l contact-green mg-r10\"></i>\n                <div class=\"contact-top-div contact-green\">\n                    <div class=\"mg-b10\">\n                        38258775-8820\n                    </div>\n                    <div class=\"contact-gray contact-bottom\">\n                        周一至周五 8:30-17:30\n                    </div>\n                </div>\n            </div>\n            <div>\n                <i class=\"iconfont i-rightbar-contacts f-l contact-green mg-r10\"></i>\n                <div class=\"contact-top-div contact-green\">\n                    <div class=\"mg-b10\">\n                        <span>13825070315</span>\n                        <span>李先生</span>\n                    </div>\n                    <div  class=\"contact-gray\">\n                        周一至周日 24小时热线\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"wx\" ng-show=\"d.wx.src\">\n        <i class=\"iconfont i-qr-code\"></i>\n        <span>关注微信</span>\n        <div class=\"l-ft\">\n            <div class=\"qr-code\">\n                <div class=\"img\">\n                    <img ng-src=\"{{d.wx.src}}\" width=\"122\" height=\"122\" rel=\"download_kuxiao_app_qr_code\" />\n                </div>\n                <span ng-bind=\"d.wx.name\"></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"dl\" ng-show=\"d.qr.src\">\n        <i class=\"iconfont i-phone\"></i>\n        <span>App下载</span>\n        <div class=\"l-ft\">\n            <div class=\"qr-code\">\n                <div class=\"img\">\n                    <img ng-src=\"{{d.qr.src}}\" width=\"122\" height=\"122\" rel=\"download_kuxiao_app_qr_code\" />\n                </div>\n                <span>{{d.qr.name}}</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"to-top\" title=\"回到顶部\" onclick=\"$('html,body').stop().animate({scrollTop:0},'fast');\">\n        <i class=\"iconfont i-top\"></i>\n        <span>回到顶部</span>\n    </div>\n</div>";

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('RCP').directive('timeAgo', ["timeAgo", "timeAgoNowTime", function (timeAgo, timeAgoNowTime) {
  return {
    scope: {
      fromTime: '@',
      format: '@'
    },
    restrict: 'EA',
    link: function link(scope, elem) {
      var fromTime;

      scope.$watch('fromTime', function () {
        fromTime = timeAgo.parse(scope.fromTime);
      });

      scope.$watch(function () {
        return timeAgoNowTime() - fromTime;
      }, function (value) {
        angular.element(elem).text(timeAgo.inWords(value, fromTime, scope.format));
      });
    }
  };
}]);

angular.module('RCP').factory('timeAgo', ["$filter", "timeAgoSettings", function ($filter, timeAgoSettings) {
  var service = {};

  service.inWords = function (distanceMillis, fromTime, format, timezone) {

    var fullDateAfterSeconds = parseInt(timeAgoSettings.fullDateAfterSeconds, 10);

    if (!isNaN(fullDateAfterSeconds)) {
      var fullDateAfterMillis = fullDateAfterSeconds * 1000;
      if (distanceMillis >= 0 && fullDateAfterMillis <= distanceMillis || distanceMillis < 0 && fullDateAfterMillis >= distanceMillis) {
        if (format) {
          return $filter('date')(fromTime, format, timezone);
        }
        return fromTime;
      }
    }

    var overrideLang = timeAgoSettings.overrideLang;
    var documentLang = document.documentElement.lang;
    var sstrings = timeAgoSettings.strings;
    var lang, $l;

    if (typeof sstrings[overrideLang] !== 'undefined') {
      lang = overrideLang;
      $l = sstrings[overrideLang];
    } else if (typeof sstrings[documentLang] !== 'undefined') {
      lang = documentLang;
      $l = sstrings[documentLang];
    } else {
      lang = 'en_US';
      $l = sstrings[lang];
    }

    var prefix = $l.prefixAgo;
    var suffix = $l.suffixAgo;
    if (timeAgoSettings.allowFuture) {
      if (distanceMillis < 0) {
        prefix = $l.prefixFromNow;
        suffix = $l.suffixFromNow;
      }
    }

    var seconds = Math.abs(distanceMillis) / 1000;
    var minutes = seconds / 60;
    var hours = minutes / 60;
    var days = hours / 24;
    var years = days / 365;

    function substitute(stringOrFunction, number) {
      number = Math.round(number);
      var string = angular.isFunction(stringOrFunction) ? stringOrFunction(number, distanceMillis) : stringOrFunction;
      var value = $l.numbers && $l.numbers[number] || number;
      return string.replace(/%d/i, value);
    }

    var breakpoints = timeAgoSettings.breakpoints;
    var words = seconds < breakpoints.secondsToMinute && substitute($l.seconds, seconds) || seconds < breakpoints.secondsToMinutes && substitute($l.minute, 1) || minutes < breakpoints.minutesToHour && substitute($l.minutes, minutes) || minutes < breakpoints.minutesToHours && substitute($l.hour, 1) || hours < breakpoints.hoursToDay && substitute($l.hours, hours) || hours < breakpoints.hoursToDays && substitute($l.day, 1) || days < breakpoints.daysToMonth && substitute($l.days, days) || days < breakpoints.daysToMonths && substitute($l.month, 1) || days < breakpoints.daysToYear && substitute($l.months, days / 30) || years < breakpoints.yearToYears && substitute($l.year, 1) || substitute($l.years, years);

    var separator = $l.wordSeparator === undefined ? ' ' : $l.wordSeparator;
    if (lang === 'he_IL') {
      return [prefix, suffix, words].join(separator).trim();
    } else {
      return [prefix, words, suffix].join(separator).trim();
    }
  };

  service.parse = function (input) {
    if (input instanceof Date) {
      return input;
    } else if (typeof moment !== 'undefined' && moment.isMoment(input)) {
      return input.toDate();
    } else if (angular.isNumber(input)) {
      return new Date(input);
    } else if (/^\d+$/.test(input)) {
      return new Date(parseInt(input, 10));
    } else {
      var s = (input || '').trim();
      s = s.replace(/\.\d+/, '');
      s = s.replace(/-/, '/').replace(/-/, '/');
      s = s.replace(/T/, ' ').replace(/Z/, ' UTC');
      s = s.replace(/([\+\-]\d\d)\:?(\d\d)/, ' $1$2');
      return new Date(s);
    }
  };

  return service;
}]);

angular.module('RCP').filter('timeAgo', ["timeAgoNowTime", "timeAgo", function (timeAgoNowTime, timeAgo) {
  function timeAgoFilter(value, format, timezone) {
    var fromTime = timeAgo.parse(value);
    var diff = timeAgoNowTime() - fromTime;
    return timeAgo.inWords(diff, fromTime, format, timezone);
  }
  timeAgoFilter.$stateful = true;
  return timeAgoFilter;
}]);

angular.module('RCP').constant('timeAgoSettings', {
  refreshMillis: 1000,
  allowFuture: false,
  overrideLang: 'zh_CN',
  fullDateAfterSeconds: null,
  strings: {},
  breakpoints: {
    secondsToMinute: 45,
    secondsToMinutes: 90,
    minutesToHour: 45,
    minutesToHours: 90,
    hoursToDay: 24,
    hoursToDays: 42,
    daysToMonth: 30,
    daysToMonths: 45,
    daysToYear: 365,
    yearToYears: 1.5 }
});

angular.module('RCP').config(["timeAgoSettings", function (timeAgoSettings) {
  timeAgoSettings.strings['zh_CN'] = {
    wordSeparator: '',
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: '前',
    suffixFromNow: '后',
    seconds: '1分钟',
    minute: '1分钟',
    minutes: '%d分钟',
    hour: '1小时',
    hours: '%d小时',
    day: '1天',
    days: '%d天',
    month: '1个月',
    months: '%d个月',
    year: '1年',
    years: '%d年',
    numbers: []
  };
}]);

angular.module('RCP').factory('timeAgoNowTime', ["$interval", "timeAgo", "timeAgoSettings", function ($interval, timeAgo, timeAgoSettings) {
  var nowTime;

  function updateTime() {
    nowTime = Date.now();
  }
  updateTime();
  $interval(updateTime, timeAgoSettings.refreshMillis);

  return function () {
    return nowTime;
  };
}]);

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _tailBar = __webpack_require__(91);

var _tailBar2 = _interopRequireDefault(_tailBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(92);

angular.module('RCP').directive('tailBar', function () {
    return {
        restrict: 'E',
        replace: true,
        template: _tailBar2.default,
        controller: ["$scope", "service", "$timeout", "$element", function controller($scope, service, $timeout, $element) {}]
    };
});

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports = "<div class=\"tail-center tail-div clearfix\">\n    <div class=\"f-l\">\n        <p>\n            <span class=\"tail-span-dif\">关于我们</span>\n            <span class=\"tail-span-dif\">联系我们</span>\n            <span class=\"tail-span-dif\">法律条款馈</span>\n            <span class=\"tail-span-dif\">帮助中心</span>\n            <span class=\"tail-span-dif\">企业申请入驻</span>\n            <span>意见反馈</span>\n        </p>\n        <p>\n            <span class=\"tail-span-dif\">Copyright © 2017 ITDAYANG. All Rights Reserved.</span>\n            <span>粤ICP备05139291号-12</span>\n        </p>\n    </div>\n    <div class=\"f-l tail-div-dif\"></div>\n    <div class=\"f-l\">\n        <p class=\"right-p\">\n            <span  class=\"big-char\">客服热线：</span>\n            <span class=\"tel-span\">38258775-8820</span>\n            <span class=\"mg-l15\">周一至周五 8:30-17:30</span>\n        </p>\n        <p>\n            <span class=\"big-char\">客服专员：</span>\n            <span class=\"tel-span\">13825070315</span>\n            <span class=\"mg-l15\">周一至周日 24小时热线</span>\n        </p>\n    </div>\n</div>";

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.CryptoJS = window.CryptoJS || function (e, m) {
    var p = {},
        j = p.lib = {},
        l = function l() {},
        f = j.Base = { extend: function extend(a) {
            l.prototype = this;var c = new l();a && c.mixIn(a);c.hasOwnProperty("init") || (c.init = function () {
                c.$super.init.apply(this, arguments);
            });c.init.prototype = c;c.$super = this;return c;
        }, create: function create() {
            var a = this.extend();a.init.apply(a, arguments);return a;
        }, init: function init() {}, mixIn: function mixIn(a) {
            for (var c in a) {
                a.hasOwnProperty(c) && (this[c] = a[c]);
            }a.hasOwnProperty("toString") && (this.toString = a.toString);
        }, clone: function clone() {
            return this.init.prototype.extend(this);
        } },
        n = j.WordArray = f.extend({ init: function init(a, c) {
            a = this.words = a || [];this.sigBytes = c != m ? c : 4 * a.length;
        }, toString: function toString(a) {
            return (a || h).stringify(this);
        }, concat: function concat(a) {
            var c = this.words,
                q = a.words,
                d = this.sigBytes;a = a.sigBytes;this.clamp();if (d % 4) for (var b = 0; b < a; b++) {
                c[d + b >>> 2] |= (q[b >>> 2] >>> 24 - 8 * (b % 4) & 255) << 24 - 8 * ((d + b) % 4);
            } else if (65535 < q.length) for (b = 0; b < a; b += 4) {
                c[d + b >>> 2] = q[b >>> 2];
            } else c.push.apply(c, q);this.sigBytes += a;return this;
        }, clamp: function clamp() {
            var a = this.words,
                c = this.sigBytes;a[c >>> 2] &= 4294967295 << 32 - 8 * (c % 4);a.length = e.ceil(c / 4);
        }, clone: function clone() {
            var a = f.clone.call(this);a.words = this.words.slice(0);return a;
        }, random: function random(a) {
            for (var c = [], b = 0; b < a; b += 4) {
                c.push(4294967296 * e.random() | 0);
            }return new n.init(c, a);
        } }),
        b = p.enc = {},
        h = b.Hex = { stringify: function stringify(a) {
            var c = a.words;a = a.sigBytes;for (var b = [], d = 0; d < a; d++) {
                var f = c[d >>> 2] >>> 24 - 8 * (d % 4) & 255;b.push((f >>> 4).toString(16));b.push((f & 15).toString(16));
            }return b.join("");
        }, parse: function parse(a) {
            for (var c = a.length, b = [], d = 0; d < c; d += 2) {
                b[d >>> 3] |= parseInt(a.substr(d, 2), 16) << 24 - 4 * (d % 8);
            }return new n.init(b, c / 2);
        } },
        g = b.Latin1 = { stringify: function stringify(a) {
            var c = a.words;a = a.sigBytes;for (var b = [], d = 0; d < a; d++) {
                b.push(String.fromCharCode(c[d >>> 2] >>> 24 - 8 * (d % 4) & 255));
            }return b.join("");
        }, parse: function parse(a) {
            for (var c = a.length, b = [], d = 0; d < c; d++) {
                b[d >>> 2] |= (a.charCodeAt(d) & 255) << 24 - 8 * (d % 4);
            }return new n.init(b, c);
        } },
        r = b.Utf8 = { stringify: function stringify(a) {
            try {
                return decodeURIComponent(escape(g.stringify(a)));
            } catch (c) {
                throw Error("Malformed UTF-8 data");
            }
        }, parse: function parse(a) {
            return g.parse(unescape(encodeURIComponent(a)));
        } },
        k = j.BufferedBlockAlgorithm = f.extend({ reset: function reset() {
            this._data = new n.init();this._nDataBytes = 0;
        }, _append: function _append(a) {
            "string" == typeof a && (a = r.parse(a));this._data.concat(a);this._nDataBytes += a.sigBytes;
        }, _process: function _process(a) {
            var c = this._data,
                b = c.words,
                d = c.sigBytes,
                f = this.blockSize,
                h = d / (4 * f),
                h = a ? e.ceil(h) : e.max((h | 0) - this._minBufferSize, 0);a = h * f;d = e.min(4 * a, d);if (a) {
                for (var g = 0; g < a; g += f) {
                    this._doProcessBlock(b, g);
                }g = b.splice(0, a);c.sigBytes -= d;
            }return new n.init(g, d);
        }, clone: function clone() {
            var a = f.clone.call(this);
            a._data = this._data.clone();return a;
        }, _minBufferSize: 0 });j.Hasher = k.extend({ cfg: f.extend(), init: function init(a) {
            this.cfg = this.cfg.extend(a);this.reset();
        }, reset: function reset() {
            k.reset.call(this);this._doReset();
        }, update: function update(a) {
            this._append(a);this._process();return this;
        }, finalize: function finalize(a) {
            a && this._append(a);return this._doFinalize();
        }, blockSize: 16, _createHelper: function _createHelper(a) {
            return function (c, b) {
                return new a.init(b).finalize(c);
            };
        }, _createHmacHelper: function _createHmacHelper(a) {
            return function (b, f) {
                return new s.HMAC.init(a, f).finalize(b);
            };
        } });var s = p.algo = {};return p;
}(Math);
(function () {
    var e = CryptoJS,
        m = e.lib,
        p = m.WordArray,
        j = m.Hasher,
        l = [],
        m = e.algo.SHA1 = j.extend({ _doReset: function _doReset() {
            this._hash = new p.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
        }, _doProcessBlock: function _doProcessBlock(f, n) {
            for (var b = this._hash.words, h = b[0], g = b[1], e = b[2], k = b[3], j = b[4], a = 0; 80 > a; a++) {
                if (16 > a) l[a] = f[n + a] | 0;else {
                    var c = l[a - 3] ^ l[a - 8] ^ l[a - 14] ^ l[a - 16];l[a] = c << 1 | c >>> 31;
                }c = (h << 5 | h >>> 27) + j + l[a];c = 20 > a ? c + ((g & e | ~g & k) + 1518500249) : 40 > a ? c + ((g ^ e ^ k) + 1859775393) : 60 > a ? c + ((g & e | g & k | e & k) - 1894007588) : c + ((g ^ e ^ k) - 899497514);j = k;k = e;e = g << 30 | g >>> 2;g = h;h = c;
            }b[0] = b[0] + h | 0;b[1] = b[1] + g | 0;b[2] = b[2] + e | 0;b[3] = b[3] + k | 0;b[4] = b[4] + j | 0;
        }, _doFinalize: function _doFinalize() {
            var f = this._data,
                e = f.words,
                b = 8 * this._nDataBytes,
                h = 8 * f.sigBytes;e[h >>> 5] |= 128 << 24 - h % 32;e[(h + 64 >>> 9 << 4) + 14] = Math.floor(b / 4294967296);e[(h + 64 >>> 9 << 4) + 15] = b;f.sigBytes = 4 * e.length;this._process();return this._hash;
        }, clone: function clone() {
            var e = j.clone.call(this);e._hash = this._hash.clone();return e;
        } });e.SHA1 = j._createHelper(m);e.HmacSHA1 = j._createHmacHelper(m);
})();

(function () {
    if ("function" == typeof ArrayBuffer) {
        var b = CryptoJS.lib.WordArray,
            e = b.init;(b.init = function (a) {
            a instanceof ArrayBuffer && (a = new Uint8Array(a));if (a instanceof Int8Array || typeof Uint8ClampedArray != 'undefined' && a instanceof Uint8ClampedArray || a instanceof Int16Array || a instanceof Uint16Array || a instanceof Int32Array || a instanceof Uint32Array || a instanceof Float32Array || a instanceof Float64Array) a = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);if (a instanceof Uint8Array) {
                for (var b = a.byteLength, d = [], c = 0; c < b; c++) {
                    d[c >>> 2] |= a[c] << 24 - 8 * (c % 4);
                }e.call(this, d, b);
            } else e.apply(this, arguments);
        }).prototype = b;
    }
})();

var C4js = function () {
    function C4js() {}

    C4js.NewAjax = function () {
        return new XMLHttpRequest();
    };
    C4js.G = function (url, success, error) {
        var req = C4js.NewAjax();
        req.onreadystatechange = function () {
            if (req.readyState == 4) {
                try {
                    if (req.status == 200) {
                        success(JSON.parse(req.responseText), req);
                    } else {
                        error(JSON.parse(req.responseText), null, req);
                    }
                } catch (e) {
                    error({}, e, req);
                }
            }
        };
        req.open("GET", url);
        req.send(null);
    };
    C4js.UrlArg = function (key) {
        var surl = window.location.search.substring(1);
        var vals = surl.split('&');
        for (var i in vals) {
            kv = vals[i].split('=');
            if (kv[0] == key) {
                return kv[1];
            }
        }
        return null;
    };
    C4js.FSize = ["B", "KB", "MB", "GB", "TB"];

    C4js.fsize = function (bs) {
        bsize = bs;
        for (var i = 0; i < C4js.FSize.length; i++) {
            if (bsize > 1024) {
                bsize = bsize / 1024;
            } else {
                return bsize.toFixed(1) + C4js.FSize[i];
            }
        }
    };
    C4js.Uer = function () {
        function Uer(url, args, auto) {
            if (url) {
                this.Url = url;
            }
            if (args) {
                this.Args = args;
            }
            if (typeof auto != 'undefined') {
                this.Auto = auto;
            }
            this.Hash = true && CryptoJS.SHA1;
            this.HashLimit = 10240000;
        }
        Uer.SOrder = {
            E: 0,
            A: 1,
            S: 2,
            P: 3,
            W: 4,
            L: 5
        };
        Uer.StatusText = function (s) {
            switch (s) {
                case "P":
                    return "上传中...";
                case "W":
                    return "等待中...";
                case "E":
                    return "上传失败";
                case "A":
                    return "已取消";
                case "L":
                    return "已完成";
                case "S":
                    return "开始上传";
            }
            return "";
        };

        Uer.prototype.files = [];
        Uer.prototype.loaded = 0;
        Uer.prototype.idc = 0;
        Uer.prototype.Auto = true;
        Uer.prototype.Maxsize = 0;
        Uer.prototype.Minsize = 0;
        Uer.prototype.Uploading = false;
        Uer.prototype.Url = "";
        Uer.prototype.Fname = "file";
        Uer.prototype.Args = {};
        Uer.prototype.C = function () {
            cval = {
                W: 0,
                P: 0,
                S: 0,
                L: 0,
                E: 0,
                A: 0,
                Speed: "",
                Loaded: this.loaded
            };
            tspeed = 0;
            for (var i in this.files) {
                cf = this.files[i];
                if (cf.speed) {
                    tspeed += cf.speed;
                }
                switch (cf.Status) {
                    case "W":
                        cval.W++;
                        break;
                    case "P":
                        cval.P++;
                        break;
                    case "S":
                        cval.S++;
                        break;
                    case "L":
                        cval.L++;
                        break;
                    case "E":
                        cval.E++;
                        break;
                    case "A":
                        cval.A++;
                        break;
                }
            }
            cval.Speed = C4js.fsize(tspeed);
            return cval;
        };
        Uer.prototype.sort = function () {
            this.files.sort(function (a, b) {
                return Uer.SOrder[a.Status] > Uer.SOrder[b.Status];
            });
        };
        Uer.prototype.addf = function (f) {
            f.Status = "W";
            f.fid = this.idc++;
            f.speed = f.rate = 0;
            this.files.push(f);
        };

        Uer.prototype.AddF = function (f, args, ev) {
            var added = [];
            var err = [];
            if (this.Maxsize && f.size > this.Maxsize) {
                err.push(f);
            } else if (this.Minsize && f.size < this.Minsize) {
                err.push(f);
            } else {
                added.push(f);
                f.Args = args;
                f.Ev = ev;
                this.addf(f);
                this.sort();
            }
            this.OnAdd(added, err);
            if (this.Auto) this.uloop();
            this.sort();
        };

        Uer.prototype.Add = function (fl, node) {
            var added = [];
            var err = [];
            for (var i = 0; i < fl.length; i++) {
                var f = fl[i];
                if (this.Maxsize && f.size > this.Maxsize) {
                    err.push(f);
                    continue;
                }
                if (this.Minsize && f.size < this.Minsize) {
                    err.push(f);
                    continue;
                }
                f.node = node;
                f.Args = node.Args;
                f.Ev = node.Ev;
                added.push(f);
                this.addf(f);
            }
            this.OnAdd(added, err);
            if (this.Auto) this.uloop();
            this.sort();
            node.value = '';
        };

        Uer.prototype.AddI = function (id, args, ev) {
            t = document.getElementById(id);
            if (!t) {
                return;
            }
            t.uer = this;
            t.Args = args;
            t.Ev = ev;
            t.addEventListener("change", this.onc);
        };

        Uer.prototype.DelI = function (id) {
            t = document.getElementById(id);
            if (!t) {
                return;
            }
            t.uer = undefined;
            t.Args = undefined;
            t.Ev = undefined;
            t.removeEventListener("change", this.onc);
        };

        Uer.prototype.FindF = function (fid) {
            for (var i = 0; i < this.files.length; i++) {
                if (this.files[i].fid == fid) {
                    return this.files[i];
                }
            }
            return null;
        };

        Uer.prototype.ClearLoaded = function () {
            var nary = [];
            for (var i = 0; i < this.files.length; i++) {
                if (this.files[i].Status != "L") {
                    nary.push(this.files[i]);
                }
            }
            this.files = nary;
        };
        Uer.prototype.onc = function (e) {
            e.preventDefault();
            t = e.srcElement || e.target;
            if (t.uer && t.files) {
                var fs = t.uer.OnSelect(t, e);
                if (fs.length) {
                    t.uer.Add(fs, t);
                }
            }
            return true;
        };
        Uer.prototype.uloop = function () {
            var f = null;
            for (var i in this.files) {
                cf = this.files[i];
                if (cf.Status == "W") {
                    f = this.files[i];
                    break;
                }
            }
            if (!f) {
                return;
            }
            var dohash = this.Hash;
            if (f.size > this.HashLimit) {
                dohash = false;
            } else if (typeof f.Hash != 'undefined') {
                dohash = f.Hash;
            }
            if (!dohash) {
                delete f.Args.sha;
                this.uloop_(f);
                return;
            }
            var uer = this;
            var fr = new FileReader();
            var btime = new Date().getTime();
            fr.onprogress = function (e) {
                uer.OnHashProc(f, e);
            };
            fr.onload = function (e) {
                var wad = CryptoJS.lib.WordArray.create(this.result);
                if (!f.Args) {
                    f.Args = {};
                }
                f.Args.sha = CryptoJS.SHA1(wad).toString(CryptoJS.enc.Hex);

                uer.uloop_(f);
            };
            fr.readAsArrayBuffer(f);
        };
        Uer.prototype.uloop_ = function (f) {
            var xhr = C4js.NewAjax();
            var upload = xhr.upload;
            var uer = this;
            xhr.onreadystatechange = function () {
                if (xhr.readyState != 4) {
                    return;
                }
                if (xhr.status == 200) {
                    try {
                        uer.OnSuccess(f, JSON.parse(xhr.responseText), null);
                    } catch (e) {
                        uer.OnSuccess(f, xhr.responseText, null);
                    }
                } else {
                    try {
                        uer.OnErr(f, JSON.parse(xhr.responseText), null);
                    } catch (e) {
                        uer.OnErr(f, xhr.responseText, null);
                    }
                }
            };
            upload.addEventListener("loadstart", function (e) {
                f.Status = "S";
                f.speed = 0;
                f.preloaded = 0;
                f.pretime = new Date().getTime() / 1000;
                if (f.node) f.node.uploading = true;
                uer.sort();
                uer.OnStart(f, e);
            }, false);
            upload.addEventListener("progress", function (e) {
                f.Status = "P";
                f.rate = 0;
                if (e.lengthComputable) {
                    f.rate = e.loaded / e.total;
                }
                ntime = new Date().getTime() / 1000;
                f.speed = (e.loaded - f.preloaded) / (ntime - f.pretime);
                speed = C4js.fsize(f.speed);
                f.preloaded = e.loaded;
                f.pretime = ntime;
                uer.OnProcess(f, f.rate, speed, e);
            }, false);
            upload.addEventListener("load", function (e) {
                f.Status = "L";
                uer.loaded++;
                uer.sort();
                if (f.node) f.node.uploading = false;
                uer.OnLoad(f, e);

                uer.uloop();
            }, false);
            upload.addEventListener("error", function (e) {
                f.Status = "E";
                uer.sort();
                uer.OnErr(f, null, e);

                uer.uloop();
            }, false);
            upload.addEventListener("abort", function (e) {
                f.Status = "A";
                uer.sort();
                uer.OnAbort(f, e);

                uer.uloop();
            }, false);
            f.Status = "P";
            form = new FormData();
            uargs = [];
            for (var k in this.Args) {
                uargs.push(k + "=" + this.Args[k]);
            }
            eargs = this.OnPrepare(f, xhr, form);
            if (eargs) {
                for (var ke in eargs) {
                    uargs.push(ke + "=" + eargs[ke]);
                }
            }
            if (f.Args) {
                for (var ka in f.Args) {
                    uargs.push(ka + "=" + f.Args[ka]);
                }
            }
            if (this.Fname.length) {
                form.append(this.Fname, f);
            }
            rurl = this.Url;
            if (rurl.indexOf("?") < 0) {
                rurl += "?" + uargs.join("&");
            } else {
                rurl += "&" + uargs.join("&");
            }
            console.log(rurl);
            xhr.open("POST", rurl);
            xhr.overrideMimeType && xhr.overrideMimeType("application/octet-stream");
            xhr.send(form);
            f.Xhr = xhr;
        };

        Uer.prototype.Abort = function (fid) {
            for (var i = 0; i < this.files.length; i++) {
                f = this.files[i];
                if (f.fid == fid && f.Xhr) {
                    f.Xhr.abort();
                }
            }
        };

        Uer.prototype.OnAdd = function (added, err) {};

        Uer.prototype.OnPrepare = function (f, xhr, form) {
            if (f.Ev && f.Ev.OnPrepare) {
                f.Ev.OnPrepare(f, xhr, form);
            }
            return {};
        };

        Uer.prototype.OnStart = function (f, e) {
            if (f.Ev && f.Ev.OnStart) {
                f.Ev.OnStart(f, e);
            }
        };

        Uer.prototype.OnProcess = function (f, rate, speed, e) {
            if (f.Ev && f.Ev.OnProcess) {
                f.Ev.OnProcess(f, rate, speed, e);
            }
        };

        Uer.prototype.OnHashProc = function (f, e) {
            if (f.Ev && f.Ev.OnHashProc) {
                f.Ev.OnHashProc(f, e);
            }
        };

        Uer.prototype.OnLoad = function (f, e) {
            if (f.Ev && f.Ev.OnLoad) {
                f.Ev.OnLoad(f, e);
            }
        };

        Uer.prototype.OnSuccess = function (f, data, e) {
            if (f.Ev && f.Ev.OnSuccess) {
                f.Ev.OnSuccess(f, data, e);
            }
        };

        Uer.prototype.OnErr = function (f, data, e) {
            if (f.Ev && f.Ev.OnErr) {
                f.Ev.OnErr(f, data, e);
            }
        };

        Uer.prototype.OnAbort = function (f, e) {
            if (f.Ev && f.Ev.OnAbort) {
                f.Ev.OnAbort(f, e);
            }
        };

        Uer.prototype.OnSelect = function (item, e) {
            return item.files;
        };
        return Uer;
    }();
    window.C4js = C4js;
    return C4js;
}();
window.GetToken = window.GetToken ? window.GetToken : function () {
    return rcpAid.getToken.call(rcpAid);
};
C4js.NewUer = function (args, auto) {
    return new C4js.Uer(DYCONFIG.uploadSrv, {
        m: "C",
        token: GetToken()
    }, auto);
};

var uer = C4js.NewUer({
    m: "C"
}, true);

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var C4js = function () {
	function C4js() {}

	C4js.NewAjax = function () {
		return new XMLHttpRequest();
	};
	C4js.G = function (url, success, error) {
		var req = C4js.NewAjax();
		req.onreadystatechange = function () {
			if (req.readyState == 4) {
				try {
					if (req.status == 200) {
						success(JSON.parse(req.responseText), req);
					} else {
						error(JSON.parse(req.responseText), null, req);
					}
				} catch (e) {
					error({}, e, req);
				}
			}
		};
		req.open("GET", url);
		req.send(null);
	};
	C4js.UrlArg = function (key) {
		var surl = window.location.search.substring(1);
		var vals = surl.split('&');
		for (var i in vals) {
			var kv = vals[i].split('=');
			if (kv[0] == key) {
				return kv[1];
			}
		}
		return null;
	};
	C4js.FSize = ["B", "KB", "MB", "GB", "TB"];

	C4js.fsize = function (bs) {
		var bsize = bs;
		for (var i = 0; i < C4js.FSize.length; i++) {
			if (bsize > 1024) {
				bsize = bsize / 1024;
			} else {
				return bsize.toFixed(1) + C4js.FSize[i];
			}
		}
	};
	C4js.Uer = function () {
		function Uer(url, args, auto) {
			if (url) {
				this.Url = url;
			}
			if (args) {
				this.Args = args;
			}
			if (typeof auto != 'undefined') {
				this.Auto = auto;
			}
			this.Hash = true && CryptoJS.SHA1;
			this.HashLimit = 10240000;
		}
		Uer.SOrder = {
			E: 0,
			A: 1,
			S: 2,
			P: 3,
			W: 4,
			L: 5
		};
		Uer.StatusText = function (s) {
			switch (s) {
				case "P":
					return "上传中...";
				case "W":
					return "等待中...";
				case "E":
					return "上传失败";
				case "A":
					return "已取消";
				case "L":
					return "已完成";
				case "S":
					return "开始上传";
			}
			return "";
		};

		Uer.prototype.files = [];
		Uer.prototype.loaded = 0;
		Uer.prototype.idc = 0;
		Uer.prototype.Auto = true;
		Uer.prototype.Maxsize = 0;
		Uer.prototype.Minsize = 0;
		Uer.prototype.Uploading = false;
		Uer.prototype.Url = "";
		Uer.prototype.Fname = "file";
		Uer.prototype.Args = {};
		Uer.prototype.C = function () {
			var cval = {
				W: 0,
				P: 0,
				S: 0,
				L: 0,
				E: 0,
				A: 0,
				Speed: "",
				Loaded: this.loaded
			};
			var tspeed = 0;
			for (var i in this.files) {
				var cf = this.files[i];
				if (cf.speed) {
					tspeed += cf.speed;
				}
				switch (cf.Status) {
					case "W":
						cval.W++;
						break;
					case "P":
						cval.P++;
						break;
					case "S":
						cval.S++;
						break;
					case "L":
						cval.L++;
						break;
					case "E":
						cval.E++;
						break;
					case "A":
						cval.A++;
						break;
				}
			}
			cval.Speed = C4js.fsize(tspeed);
			return cval;
		};
		Uer.prototype.sort = function () {
			this.files.sort(function (a, b) {
				return Uer.SOrder[a.Status] > Uer.SOrder[b.Status];
			});
		};
		Uer.prototype.addf = function (f) {
			f.Status = "W";
			f.fid = this.idc++;
			f.speed = f.rate = 0;
			this.files.push(f);
		};

		Uer.prototype.AddF = function (f, args, ev) {
			var added = [];
			var err = [];
			if (this.Maxsize && f.size > this.Maxsize) {
				err.push(f);
			} else if (this.Minsize && f.size < this.Minsize) {
				err.push(f);
			} else {
				added.push(f);
				f.Args = args;
				f.Ev = ev;
				this.addf(f);
				this.sort();
			}
			this.OnAdd(added, err);
			if (this.Auto) this.uloop();
			this.sort();
		};

		Uer.prototype.Add = function (fl, node) {
			var added = [];
			var err = [];
			for (var i = 0; i < fl.length; i++) {
				var f = fl[i];
				if (this.Maxsize && f.size > this.Maxsize) {
					err.push(f);
					continue;
				}
				if (this.Minsize && f.size < this.Minsize) {
					err.push(f);
					continue;
				}
				f.node = node;
				f.Args = node.Args;
				f.Ev = node.Ev;
				added.push(f);
				this.addf(f);
			}
			this.OnAdd(added, err);
			if (this.Auto) this.uloop();
			this.sort();
			node.value = '';
		};

		Uer.prototype.AddI = function (id, args, ev) {
			var t = document.getElementById(id);
			if (!t) {
				return;
			}
			t.uer = this;
			t.Args = args;
			t.Ev = ev;
			t.addEventListener("change", this.onc);
		};

		Uer.prototype.DelI = function (id) {
			var t = document.getElementById(id);
			if (!t) {
				return;
			}
			t.uer = undefined;
			t.Args = undefined;
			t.Ev = undefined;
			t.removeEventListener("change", this.onc);
		};

		Uer.prototype.FindF = function (fid) {
			for (var i = 0; i < this.files.length; i++) {
				if (this.files[i].fid == fid) {
					return this.files[i];
				}
			}
			return null;
		};

		Uer.prototype.ClearLoaded = function () {
			var nary = [];
			for (var i = 0; i < this.files.length; i++) {
				if (this.files[i].Status != "L") {
					nary.push(this.files[i]);
				}
			}
			this.files = nary;
		};
		Uer.prototype.onc = function (e) {
			e.preventDefault();
			var t = e.srcElement || e.target;
			if (t.uer && t.files) {
				var fs = t.uer.OnSelect(t, e);
				if (fs.length) {
					t.uer.Add(fs, t);
				}
			}
			return true;
		};
		Uer.prototype.uloop = function () {
			var f = null;
			for (var i in this.files) {
				var cf = this.files[i];
				if (cf.Status == "W") {
					f = this.files[i];
					break;
				}
			}
			if (!f) {
				return;
			}
			var dohash = this.Hash;
			if (f.size > this.HashLimit) {
				dohash = false;
			} else if (typeof f.Hash != 'undefined') {
				dohash = f.Hash;
			}
			if (!dohash) {
				delete f.Args.sha;
				this.uloop_(f);
				return;
			}
			var uer = this;
			var fr = new FileReader();
			var btime = new Date().getTime();
			fr.onprogress = function (e) {
				uer.OnHashProc(f, e);
			};
			fr.onload = function (e) {
				var wad = CryptoJS.lib.WordArray.create(this.result);
				if (!f.Args) {
					f.Args = {};
				}
				f.Args.sha = CryptoJS.SHA1(wad).toString(CryptoJS.enc.Hex);

				uer.uloop_(f);
			};
			fr.readAsArrayBuffer(f);
		};
		Uer.prototype.uloop_ = function (f) {
			var xhr = C4js.NewAjax();
			var upload = xhr.upload;
			var uer = this;
			xhr.onreadystatechange = function () {
				if (xhr.readyState != 4) {
					return;
				}
				if (xhr.status == 200) {
					try {
						uer.OnSuccess(f, JSON.parse(xhr.responseText), null);
					} catch (e) {
						uer.OnSuccess(f, xhr.responseText, null);
					}
				} else {
					try {
						uer.OnErr(f, JSON.parse(xhr.responseText), null);
					} catch (e) {
						uer.OnErr(f, xhr.responseText, null);
					}
				}
			};
			upload.addEventListener("loadstart", function (e) {
				f.Status = "S";
				f.speed = 0;
				f.preloaded = 0;
				f.pretime = new Date().getTime() / 1000;
				if (f.node) f.node.uploading = true;
				uer.sort();
				uer.OnStart(f, e);
			}, false);
			upload.addEventListener("progress", function (e) {
				f.Status = "P";
				f.rate = 0;
				if (e.lengthComputable) {
					f.rate = e.loaded / e.total;
				}
				var ntime = new Date().getTime() / 1000;
				f.speed = (e.loaded - f.preloaded) / (ntime - f.pretime);
				var speed = C4js.fsize(f.speed);
				f.preloaded = e.loaded;
				f.pretime = ntime;
				uer.OnProcess(f, f.rate, speed, e);
			}, false);
			upload.addEventListener("load", function (e) {
				f.Status = "L";
				uer.loaded++;
				uer.sort();
				if (f.node) f.node.uploading = false;
				uer.OnLoad(f, e);

				uer.uloop();
			}, false);
			upload.addEventListener("error", function (e) {
				f.Status = "E";
				uer.sort();
				uer.OnErr(f, null, e);

				uer.uloop();
			}, false);
			upload.addEventListener("abort", function (e) {
				f.Status = "A";
				uer.sort();
				uer.OnAbort(f, e);

				uer.uloop();
			}, false);
			f.Status = "P";
			var form = new FormData();
			var uargs = [];
			for (var k in this.Args) {
				uargs.push(k + "=" + this.Args[k]);
			}
			var eargs = this.OnPrepare(f, xhr, form);
			if (eargs) {
				for (var ke in eargs) {
					uargs.push(ke + "=" + eargs[ke]);
				}
			}
			if (f.Args) {
				for (var ka in f.Args) {
					uargs.push(ka + "=" + f.Args[ka]);
				}
			}
			if (this.Fname.length) {
				form.append(this.Fname, f);
			}
			var rurl = this.Url;
			if (rurl.indexOf("?") < 0) {
				rurl += "?" + uargs.join("&");
			} else {
				rurl += "&" + uargs.join("&");
			}
			xhr.open("POST", rurl);
			xhr.overrideMimeType && xhr.overrideMimeType("application/octet-stream");
			xhr.send(form);
			f.Xhr = xhr;
		};

		Uer.prototype.Abort = function (fid) {
			for (var i = 0; i < this.files.length; i++) {
				var f = this.files[i];
				if (f.fid == fid && f.Xhr) {
					f.Xhr.abort();
				}
			}
		};

		Uer.prototype.OnAdd = function (added, err) {};

		Uer.prototype.OnPrepare = function (f, xhr, form) {
			if (f.Ev && f.Ev.OnPrepare) {
				f.Ev.OnPrepare(f, xhr, form);
			}
			return {};
		};

		Uer.prototype.OnStart = function (f, e) {
			if (f.Ev && f.Ev.OnStart) {
				f.Ev.OnStart(f, e);
			}
		};

		Uer.prototype.OnProcess = function (f, rate, speed, e) {
			if (f.Ev && f.Ev.OnProcess) {
				f.Ev.OnProcess(f, rate, speed, e);
			}
		};

		Uer.prototype.OnHashProc = function (f, e) {
			if (f.Ev && f.Ev.OnHashProc) {
				f.Ev.OnHashProc(f, e);
			}
		};

		Uer.prototype.OnLoad = function (f, e) {
			if (f.Ev && f.Ev.OnLoad) {
				f.Ev.OnLoad(f, e);
			}
		};

		Uer.prototype.OnSuccess = function (f, data, e) {
			if (f.Ev && f.Ev.OnSuccess) {
				f.Ev.OnSuccess(f, data, e);
			}
		};

		Uer.prototype.OnErr = function (f, data, e) {
			if (f.Ev && f.Ev.OnErr) {
				f.Ev.OnErr(f, data, e);
			}
		};

		Uer.prototype.OnAbort = function (f, e) {
			if (f.Ev && f.Ev.OnAbort) {
				f.Ev.OnAbort(f, e);
			}
		};

		Uer.prototype.OnSelect = function (item, e) {
			return item.files;
		};
		return Uer;
	}();
	window.C4js = C4js;
	return C4js;
}();

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


C4js.NewUer = function (args, auto) {
    return new C4js.Uer(DYCONFIG.uploadSrv, {
        m: "C",
        token: GetToken()
    }, auto);
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/recruit-index.a9eeb0040f30134cf114.js